import { c as _c } from "react/compiler-runtime";
import { PRICE_CALENDAR_URL } from "@website/accommodation-ui/constant/addresses";
import { PriceCalendarResponseItem } from "@website/accommodation-ui/price-calendar-wrapper/types";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";
interface Properties {
  stDate: string;
  rtDate: string;
  origin: string;
  dest: string;
  passengers: Array<{
    adultCount: number;
    children: Array<number>;
  }>;
}
export const useQueryPriceCalendar = t0 => {
  const $ = _c(14);
  const {
    stDate,
    rtDate,
    origin,
    dest,
    passengers
  } = t0;
  let t1;
  if ($[0] !== dest || $[1] !== origin || $[2] !== rtDate || $[3] !== stDate) {
    t1 = [PRICE_CALENDAR_URL, origin, dest, stDate, rtDate];
    $[0] = dest;
    $[1] = origin;
    $[2] = rtDate;
    $[3] = stDate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== dest || $[6] !== origin || $[7] !== passengers || $[8] !== rtDate || $[9] !== stDate) {
    t2 = () => fetcher({
      url: PRICE_CALENDAR_URL,
      method: "POST",
      headers: {
        clientId: getChannel() as Channels
      },
      data: {
        origin,
        destination: dest,
        departureDate: stDate,
        returnDate: rtDate,
        rooms: passengers
      }
    }).then(_temp);
    $[5] = dest;
    $[6] = origin;
    $[7] = passengers;
    $[8] = rtDate;
    $[9] = stDate;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return useFetcher(t3);
};
function _temp(response) {
  return response.data;
}